var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'resize-dashed-line '+_vm.data.type,style:({left:(_vm.data.type=='row'?'0':_vm.data.left+40+_vm.data.size-_vm.offset.offsetLeft)+'px',
     top:(_vm.data.type=='col'?'0':_vm.data.top+30+_vm.data.size-_vm.offset.offsetTop)+'px',})})
}
var staticRenderFns = []

export { render, staticRenderFns }